import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Pagination } from 'antd';
import "./PagamentosTable.css";

const PagamentosTable = ({ listCanals }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const rows = listCanals ?? [];
  const paginatedRows = rows.slice((page - 1) * pageSize, page * pageSize);

  useEffect(() => {
    const lastPage = Math.max(1, Math.ceil(rows.length / pageSize));
    if (page > lastPage) setPage(lastPage);
  }, [rows.length, page, pageSize]);

  return (
    <>
    <table className="table table-bordered">
      <thead>
        <tr>
          <th className="text-muted">Data</th>
          <th className="text-muted">Forma de pagamento</th>
          <th className="text-muted">Cupom</th>
          <th className="text-muted">Placa</th>
          <th className="text-muted">Qtd Litros</th>
          <th className="text-muted">Valor</th>
          <th className="text-muted">Identificador</th>
          <th className="text-muted">Status</th>
        </tr>
      </thead>
      <tbody>
        {paginatedRows.map((canal, index) => (
          <tr key={index}>
            <td>{moment(canal?.data)?.format("DD/MM/YYYY HH:mm:ss")}</td>
            <td>{canal?.tipo === "bank_transfer"
            ? "PIX"
            : canal?.tipo === "CASH"
            ? "Especie"
            : canal?.tipo === "REMOTO"
            ? "Controle Remoto"
            : canal?.tipo === "MODEIRO"
            ? "Modeiro"
            : canal?.tipo === "NOTEIRO"
            ? "Noteiro"
            : canal?.tipo === "debit_card"
            ? "Débito"
            : canal?.tipo === "credit_card"
            ? "Crédito"
            : canal?.tipo === "1"
            ? "Crédito"
            : canal?.tipo === "11"
            ? "PIX"
            : canal?.tipo === "cortesia"
            ? "Cortesia"
            : canal?.tipo === "8"
            ? "Débito"
            : "-"}</td>
            <td>{new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            }).format(canal?.valor)}
            </td>
            <td>{canal?.cupom? canal?.cupom:'-'}</td>
            <td>{canal?.qtdLitro > 0? canal?.qtdLitro+'L':'-'}</td>
            <td>{canal?.placa? canal?.placa:'-'}</td>
            <td>{canal?.operadora && canal?.operadora === 'BALCAO'?'Balcão': canal?.mercadoPagoId}</td>
            <td>
                <OverlayTrigger
                    key={canal.key}
                    placement="bottom"
                    popperConfig={{ modifiers: [{ name: "preventOverflow", enabled: false }] }}
                    overlay={
                    <Tooltip id={`tooltip-top-${canal.key}`} style={{ zIndex: 1050 }}>
                        {canal?.motivoEstorno
                        ? canal?.motivoEstorno
                        : "Sem motivo registrado"}
                    </Tooltip>
                    }
                >
                    <span
                        className={`badge ${
                            canal?.estornado
                            ? "bg-light"
                            : "bg-success"
                        }`}
                    >
                        {canal?.estornado ? "Estornado" : "Recebido"}
                    </span>
                </OverlayTrigger>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    {rows.length > 10 && (
      <Pagination
        className="px-table-pagination"
        current={page}
        pageSize={pageSize}
        total={rows.length}
        showSizeChanger
        pageSizeOptions={["10", "20", "50"]}
        onChange={(nextPage, nextPageSize) => {
          setPage(nextPageSize !== pageSize ? 1 : nextPage);
          setPageSize(nextPageSize);
        }}
      />
    )}
    </>
  );
};

export default PagamentosTable;
